import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import Button from '../../components/elements/Button';
import { useOverlayContext } from '../../components/overlay/OverlayProvider';
import EventsUtil from '../../utils/EventsUtil';
import ButtonChecked from '../../components/elements/ButtonChecked';
import { handleErrorResponse, showConfirmationDialog } from '../../redux-actions/actionsApp';
import storeModel from '../../models/storeModel';
import { fetchEvents } from '../../redux-actions/actionsEvents';

interface EventAttendProps {
  isAttending: boolean;
  canAttend: boolean;
  eventPath: string;
  attendanceType: string;
  id: number;
}

const EventAttend: React.FC<EventAttendProps> = ({ isAttending, canAttend, attendanceType, eventPath, id }) => {
  const { overlayNavigate } = useOverlayContext();
  const [loading, setLoading] = useState(false);
  // const [feedback, setFeedback] = useState('');
  const feedbackRef = useRef('');
  const dispatch = useDispatch();

  if ((!canAttend && !isAttending) || attendanceType !== 'register') {
    return null;
  }

  const handleOnClickRegister = () => {
    overlayNavigate(`${eventPath}/register`);
  };

  const handleOnClickUnattend = async () => {
    const feedback = feedbackRef.current;

    setLoading(true);
    try {
      await EventsUtil.attendEvent(id, true, feedback);
      feedbackRef.current = '';
      await dispatch(fetchEvents());
    } catch (error) {
      storeModel.dispatch(handleErrorResponse(error.response));
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmUnattend = () => {
    dispatch(
      showConfirmationDialog({
        heading: 'Cancel Registration?',
        text: `<p>You're currently registered for this event. Are you sure you want to cancel your participation?</p>
          <p>We'd appreciate it if you could let us know why you're cancelling - your feedback help us improve.</p>`,
        confirmLabel: 'Yes, cancel registration',
        cancelLabel: 'Go back',
        onConfirm: handleOnClickUnattend,
        customInput: {
          placeholder: 'Your Feedback (optional)',
          value: feedbackRef.current,
          onChange: (val: string) => {
            feedbackRef.current = val;
          },
        },
      })
    );
  };

  return (
    <>
      {isAttending ? (
        canAttend ? (
          <Button
            layout="secondary"
            onClick={handleConfirmUnattend}
            label={loading ? 'Cancelling...' : 'Cancel registration'}
            disabled={loading}
          />
        ) : (
          <ButtonChecked label="Already registered" />
        )
      ) : canAttend ? (
        <Button layout="secondary" onClick={handleOnClickRegister} label="Register for this Event" />
      ) : null}
    </>
  );
};

export default EventAttend;
